module.exports = __webpack_public_path__ + "static/media/234.45158696.wav";